import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyBenefitsById($id: MongoID!) {
    cat {
      distributionSubcategory{
        byId(_id: $id) {
          _id
          staffingAgency {
            benefits {
              payrollRunTime
              healthBenefits
              pto
              holidays
              _holidays {
                _id
                name
              }
            } 
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyBenefitsById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useStaffingAgencyBenefitsById = (id: string): StaffingAgencyBenefitsById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distribution = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distribution
}

export { useStaffingAgencyBenefitsById, document as staffingAgencyBenefitsByIdDocument }
